import { ProductCategoryEnum } from "src/app/core/enums/product-category.enum";

export interface IncentiveTravelRequirement {
    id?: number;
    requirementId?: string; // UUID original del backend
    incentiveTravelId?: string;
    providerId: number;
    productCategoryId: ProductCategoryEnum;
    minimumQuantity: number;
    brand: string;
    centerGroupId: number;
}

// Interfaz para las requests al backend (según swagger)
export interface IncentiveTravelRequirementRequest {
    providerId: number;
    productCategoryId: ProductCategoryEnum;
    minimumQuantity: number;
    brand: string;
}

// Interfaz para la respuesta del backend API
export interface IncentiveTravelRequirementApiResponse {
    requirementId: string;
    providerName: string | null;
    categoryName: string | null;
    minimumQuantity: number;
    brand: string;
    centerGroupId: number;
    // Campos adicionales que pueden venir del backend
    providerId?: number;
    productCategoryId?: ProductCategoryEnum;
    incentiveTravelId?: string;
}

export interface Provider {
    id: number;
    name: string;
    connectionType: number;
    email: string;
    address: string;
    fiscalType: number;
    fiscalAddress: string;
    centerId: number;
    centerName: string;
    lastStockImportDate: string;
    contact: {
        id: number;
        fullName: string;
        phone: string;
        email: string;
    };
}
